export const ENV = {
  VITE_FRONTEND_URL: import.meta.env.VITE_FRONTEND_URL as string,
  VITE_BACKEND_API_URL: import.meta.env.VITE_BACKEND_API_URL as string,
  VITE_NODE: import.meta.env.VITE_NODE as "DEV" | "STAGE" | "PROD",
  VITE_APP_ENV: import.meta.env.VITE_APP_ENV as "local" | undefined,
  VITE_IMAGE_API_ENDPOINT: import.meta.env.VITE_IMAGE_API_ENDPOINT as string,
  VITE_AWS_IMAGES_BUCKET: import.meta.env.VITE_AWS_IMAGES_BUCKET as string,
};
